import { useMemo } from "react";

import { typedQueryClient } from "hooks/useTypedQuery";
import { DealerOverviewDashboardQueryKeys } from "modules/DealerOverviewDashboard/queryKeys";

import type { WebSocketMessageListener } from "components";
import type { DealerReportThreshold } from "models";

export const useThresholdSettingsListeners = (dealerId?: number) =>
  useMemo(() => {
    if (!dealerId) return [];

    const thresholdListeners: WebSocketMessageListener<DealerReportThreshold>[] = [
      {
        model: "DealerReportThreshold",
        action: "upsert",
        filter: { dealer_id: dealerId },
        callback: ({ data: threshold }) => {
          const thresholds = typedQueryClient.getQueryData(DealerOverviewDashboardQueryKeys.thresholds(dealerId));
          if (!thresholds) return;

          const thresholdIdx = thresholds.findIndex(tr => tr.dealer_report_column === threshold.dealer_report_column);

          typedQueryClient.setQueryData(
            DealerOverviewDashboardQueryKeys.thresholds(dealerId),
            thresholdIdx === -1 ? [...thresholds, threshold] : thresholds.with(thresholdIdx, threshold)
          );
        }
      }
    ];

    return thresholdListeners;
  }, [dealerId]);
